import { createApiHook } from '../hooks';
import { campaignLevelConversionsApiFactory } from './campaignLevelConversionsApiFactory';

export const useCampaignLevelConversionsApi = createApiHook(campaignLevelConversionsApiFactory);
